import { get, post } from '@api/request';

export async function fetchCacheLog(
  { recalculationService },
  authenticationToken,
) {
  const url = `${recalculationService}/recalc/cache/log`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function rebuildCache(
  { recalculationService },
  authenticationToken,
) {
  const url = `${recalculationService}/recalc/cache/rebuild`;
  const { body } = await post(authenticationToken, url);
  return body;
}
